var map = {
	"./forgot-form.es.js": 541,
	"./login-form.es.js": 542,
	"./recaptcha.es.js": 41,
	"./wizard.es.js": 544
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540;


//////////////////
// WEBPACK FOOTER
// ./components/login-wizard/widget \.js$
// module id = 540
// module chunks = 2